export default {
	common: {
		day: 'Day - Tag',
		month: 'Month - Monat',
		year: 'Year - Jahr',

		defaultSelectionValue: 'Please select - Bitte auswählen',
		yesAnswer: 'Yes - Ja',
		noAnswer: 'No - Nein',

		// action
		ok: 'OK',
		cancel: 'Cancel - Abbrechen',
		delete: 'Delete - Löschen',

		//button
		nextBtn: 'Next - Weiter',
		verifyBtn: 'Verify - Bestätigen',
		previousBtn: 'Previous - Vorherige',

		// step 3
		uploadFilesBtn: 'Upload Files - Daten hochladen',
		chooseFileBtn: 'Choose File - Datei wählen',

		// step 4
		noToAllBtn: 'No to all - Nein zu allem',
		addConditionBtn: 'Add condition - Bedingung hinzufügen',
		removeAnswer: 'Remove answer - Antwort entfernen',
		answer: 'Antworten',

		//step 5
		buyNowBtn: 'BUY NOW - KAUFE JETZT',
		applyNowBtn: 'APPLY NOW - JETZT BEWERBEN',

		// contact us
		sendBtn: 'Send - Senden',
		closeBtn: 'Close - Nah dran',

		step1: 'Richtlinie',
		step2: 'Quote',
		step3: 'Einzelheiten',
		step4: 'Medizin',
		step5: 'Bewerben',

		// check same policy
		samePolicy: 'Gleich wie Versicherungsnehmer?',
	},

	popup: {
		childOnlyPolicy: 'Richtlinie nur für Kinder',
		childOnlyPolicyContent: `<p>
        </p>
          <p>
            Angehörige/Kinder müssen zwischen 10 und 17 Jahre alt sein und eine Nur-Kinder-Police haben.
          </p>
        <p>
      </p>`,

		relationshipToThePolicyHolder: 'Warum fragen wir das?',
		relationshipToThePolicyHolderContent: `<p>
                                              Kinder können der Police eines Mitglieds hinzugefügt werden, müssen jedoch unter sein
                                              Alter 19 und unverheiratet (oder unter 25 Jahren, unverheiratet und in Vollzeit
                                              Weiterbildung) zu ihrem Eintrittsdatum.
                                            </p>
                                            <p>
                                              Kinder können unter dieser Police bis zum Jahresende versichert bleiben
                                              Erneuerungsdatum nach ihrem 19. Geburtstag (oder 25. Geburtstag wo in
                                              Vollzeitausbildung) oder Heirat, zu diesem Zeitpunkt ihren Versicherungsschutz
                                              unter dieser Police enden und sie können zu ihrer eigenen Police übergehen.
                                            </p>
                                            <p>
                                              Wir bieten nur Kinderpolicen nur für Kinder zwischen 10 Jahren an
                                              und 17. Für diese Policen gilt eine obligatorische Selbstbeteiligung von $/€/£ 100 pro
                                              Klage.
                                            </p>
                                            <p>
                                              Alle Kinder unter 10 Jahren müssen von einem Erwachsenen abgedeckt werden
                                              auf die Politik.
                                            </p>`,

		KYCWording: 'Kennen Sie Ihre Kundendokumente (KYC).',
		KYCWordingContent: `<ul style="list-style-type: none">
                        <li style="margin-bottom: 25px;">
                          <div style="margin-bottom: 8px;">Identitätsnachweis (Bildversion)</div>
                          Kopie eines der folgenden <strong>für den Versicherungsnehmer und für jede zu versichernde Person</strong>:
                          <ul style="list-style-type: '- '">
                            <li>Gültiger Reisepass</li>
                            <li>Gültiger Führerschein</li>
                            <li>Gültiger Personalausweis</li>
                          </ul>
                        </li>
                        <li style="margin-bottom: 25px;">
                          <div style="margin-bottom: 8px;"> Adressnachweis (falls erforderlich) </div>
                          Kopie eines der folgenden Dokumente, datiert innerhalb von 6 Monaten nach dem Gründungsdatum und ohne PO
                          Box-Adressen <strong>nur für den Versicherungsnehmer</strong>:
                          <ul style="list-style-type: '- '">
                            <li>Aktuelle Stromrechnung</li>
                            <li>Bank- oder Kreditkartenabrechnung</li>
                            <li>Referenz eines Buchhalters, Anwalts, Bankmanagers (Vorlage auf Anfrage erhältlich).</li>
                          </ul>
                        </li>
                      </ul>`,

		confirmRemoveFamily: 'Entfernen bestätigen',
		confirmRemoveFamilyContent: 'Möchten Sie dieses Familienmitglied wirklich entfernen?',

		// step2
		excess: 'Überschuss',
		excessContent: `<p>
                      <p>
                        Die Selbstbeteiligung ist der Betrag, den Sie für jeden Anspruch zahlen müssen, den Sie bei Ihrer Versicherung geltend machen. Die Selbstbeteiligung gilt für jede in der Police genannte Person.
                      </p>
                      <p>
                        Wenn Sie beispielsweise eine Selbstbeteiligung von 2.500 £ pro Person und Jahr haben, müssen Sie die ersten 2.500 £ für die Kosten aller von Ihnen geltend gemachten Ansprüche bezahlen.
                        Wenn Sie einen Anspruch von £ 1.000 geltend gemacht haben, zahlen Sie den gesamten Anspruch.
                        Wenn Sie dann einen weiteren Anspruch auf 3.000 £ geltend machen, zahlen Sie die ersten 1.500 £ und wir zahlen die restlichen 1.500 £.
                      </p>
                      <p>
                        Die Selbstbeteiligung gilt nicht für Evakuierung und Rückführung, Wellnessleistungen, Geldleistungen und zahnärztliche Leistungen.
                      </p>
                    </p>`,

		coInsurance: 'Mitversicherung',
		coInsuranceContent: `<p>
                            <strong style="padding-bottom: 1rem; display: inline-block;">Ambulante Mitversicherung</strong>
                            <br>
                            Mit der Auswahl dieser Leistung erklären Sie sich bereit, den gewählten Prozentsatz der anfallenden Kosten für alle ambulanten Leistungen zu übernehmen. (Ambulante Leistungen sind z. B. Arztbesuche, Medikamente usw. - eine vollständige Liste der ambulanten Leistungen finden Sie in der Leistungstabelle).
                          </p>`,

		paymentFrequencyContent: `<p>
		It will cost more money to pay the insurance by instalments, a discount is applied if you pay for the insurance annually. 
						</p>`,

		benefit: 'Vorteile',
		homeEvacBenefitWording: `<div>
                            <p class="fw-bold">EVAKUIERUNG IN DAS HEIMLAND – OPTIONALE LEISTUNG </p>
                            <div>
                                <p>
                                  Die Kosten für den medizinischen Notfalltransport und die medizinische Versorgung unterwegs für eine versicherte Person, die sich in einem kritischen Gesundheitszustand befindet, und die örtlichen medizinischen Einrichtungen sind unzureichend oder nicht verfügbar.
                                </p>
                                <p>
                                  Der Transport erfolgt in das Heimatland, sofern dies medizinisch vertretbar ist, wobei die versicherte Person nach der Behandlung in ihr Wohnsitzland zurückgebracht wird.
                                </p>
                            </div>
                            <p class="mb-1">Wenn Ihr Heimatland die Vereinigten Staaten von Amerika sind, endet Ihre Police automatisch nach 90 Tagen in Ihrem Heimatland.
                              Bitte beachten Sie, dass keine Abdeckung verfügbar ist:
                            </p>
                            <ul>
                              <li>Wenn Ihr Heimatland nicht in dem von Ihnen gewählten Versicherungsgebiet liegt, das auf Ihrer Versicherungsbescheinigung angegeben ist. </li>
                              <li>Alle nachfolgenden Überführungskosten, die aufgrund derselben Krankheit entstehen, nachdem wir die versicherte Person in ihr Heimatland zurückgebracht haben. </li>
                              <li>Reisekosten, sofern nicht ausdrücklich von uns vereinbart und vor Reiseantritt schriftlich bestätigt. </li>
                              <li>Überführungskosten, wenn die versicherte Person nicht zur medizinischen Behandlung in ein Krankenhaus eingeliefert wird oder wenn die Kosten vor Reiseantritt nicht von uns genehmigt wurden. </li>
                              <li>Die Verlegung einer schwangeren Frau in ein Krankenhaus zur routinemäßigen Entbindung, es sei denn, dies ist aufgrund medizinischer Komplikationen erforderlich. </li>
                            </ul>
                          </div>`,
		flexibleChoicesBenefitWording: `<ul style="list-style-type: none;  ">
						  <strong style="padding-bottom: 1rem; display: inline-block;">Flexible Choices Benefit Wording</strong>  
						  <li>
						  <p style="display: inline-block;text-decoration: underline">Out-Patient Module 1</p>
						  <p>
						  Covering everyday treatment with an annual limit of $2,500. 
						  </p>
						   </li>
						  <li>
						  <p style="display: inline-block;text-decoration: underline">Out-Patient Module 2
						  </p>
						  <p>
						   Covering everyday treatment with an annual limit of $6,000.
						   </p>
						   </li>
						   <li>
						  <p style="display: inline-block;text-decoration: underline">Dental Module
						  </p>
						  <p>
						   Covering Routine and Major Dental treatment.   
						   </p>
						   </li>
						   <li>
						   <p style="display: inline-block;text-decoration: underline">Maternity Module
						   </p>
						   <p>
							Covering Routine Pregnancy & Childbirth, Complications and Premature Baby costs.     
							</p>
							</li>
							<li>
						   <p style="display: inline-block;text-decoration: underline">Enhanced Network Module
						   </p>
						   <p>
							Opinion to enhance your network to give free choice of medical providers.     
							</p>
							</li>
						  </ul>`,
		underwriting: 'Auswahlhilfe',
		underwritingContent: `<p>
                            <p>Wir bewerten Risiken wie unten gezeigt auf unterschiedliche Weise.</p>
                            <p class="fw-bold">a. Vollständige Krankenversicherung</p>
                            <p>Wenn Sie sich für Full Medical Underwriting (FMU) entscheiden, prüfen wir die bereitgestellten Informationen, um festzustellen, ob Sie und alle berechtigten Angehörigen mit oder ohne spezifische Ausschlüsse oder Bedingungen akzeptiert werden.</p>
                            <p>Vorerkrankungen, die nicht in Ihrem FMU-Antrag angegeben sind, sind möglicherweise nicht durch Ihre Police abgedeckt.</p>
                            <p>Falls bestimmte Ausschlüsse oder Bedingungen für Ihre Police gelten, werden wir Sie schriftlich darüber informieren und Sie müssen uns schriftlich bestätigen, dass Sie die angebotenen Bedingungen akzeptiert haben, bevor Ihre Police beginnen kann.</p>

                            <p class="fw-bold">b. Moratorium Underwriting</p>
                            <p>Moratorium Underwriting ist nur verfügbar, wenn Sie und alle anspruchsberechtigten Angehörigen zu Beginn der Police jünger als 55 Jahre sind.</p>
                            <p>Moratorium Underwriting bedeutet, dass Sie und anspruchsberechtigte Angehörige nicht für Vorerkrankungen versichert sind, die in den 5 Jahren vor Ihrem Eintrittsdatum bestanden haben. Nach 2 Jahren ununterbrochener Deckung können vorbestehende Erkrankungen anspruchsberechtigt werden (es sei denn, die Erkrankung wird ausdrücklich durch die Police ausgeschlossen), wenn Sie/Ihr Angehöriger zum ersten Mal, als Sie eine Behandlung erhalten, Folgendes nicht getan haben:</p>
                            <ul class="fw-bold">
                              <li>Irgendwelche Symptome erlitten;</li>
                              <li>Konsultierte einen Arzt für Untersuchungen/Überwachung eines Zustands, erhielt Nachsorgeuntersuchungen, medizinische Behandlung oder Beratung;</li>
                              <li>Medikamente verschrieben oder eingenommen wurden, einschließlich rezeptfreier Medikamente, spezieller Diäten, Injektionen oder Physiotherapie;</li>
                              <li>Und Sie waren sich nicht bewusst, dass die Bedingung existierte. </li>
                            </ul>
                            <p>Wenn Zweifel bestehen, ob vor Beginn der Police ein Zustand bestand, behalten wir uns das Recht vor, ein weiteres ärztliches Gutachten anzufordern. Die endgültige Entscheidung, ob eine Erkrankung abgedeckt ist, liegt ausschließlich bei unserem Chief Medical Officer (CMO).</p>
                          </p>`,

		// step 5
		paymentSuccessTitle: 'Akzeptiert',
		paymentSuccess: `<p>Herzliche Glückwünsche! Ihre Bewerbung war erfolgreich.</p>
          <p>Vielen Dank, dass Sie sich für eine Krankenversicherung von Morgan Price entschieden haben. Damit sind Sie während der Vertragslaufzeit problemlos versichert.</p>
          <p>Bitte überprüfen Sie sorgfältig das Policenzertifikat, das wir Ihnen per E-Mail zugesandt haben.</p>
          <p>Hier können Sie unsere App herunterladen: <a href="https://www.morgan-price.com/app/">https://www.morgan-price.com/app/</a></p>`,

		paymentDeclinedTitle: 'Zurückgegangen',
		paymentDeclined: `Ihre Zahlung wurde abgelehnt. Bitte versuchen Sie entweder erneut zu bezahlen oder wählen Sie Jetzt beantragen und einer unserer Mitarbeiter wird sich in Kürze mit Ihnen in Verbindung setzen, um die Einrichtung Ihrer Police abzuschließen.`,

		paymentExceptionTitle: 'Ausnahme',
		paymentException:
			'Möglicherweise ist bei Ihrer Zahlung ein Problem aufgetreten. Bitte versuchen Sie nicht, erneut zu bezahlen. Wenn die Zahlung fehlgeschlagen ist, wird sich unser Team in Kürze mit Ihnen in Verbindung setzen.',

		applySuccessMessage: 'Antrag erfolgreich',
		applySuccessDeclinePaymentMessage: `<p>
			Vielen Dank, für Ihre Antragstellung für ein Produkt von Morgan Price Healthcare. Da Sie es abgelehnt haben, online zu bezahlen, wird der Antrag von einem Mitglied unseres Teams geprüft, welches sich in Kürze mit Ihnen in Verbindung setzen wird. Vielen Dank für Ihre Geduld.
		</p>`,
		applySuccessWithYesAnswerMessage: `<p>
			Vielen Dank, für Ihre Antragstellung für ein Produkt von Morgan Price Healthcare. Da Sie einige Fragen mit "Ja" beantwortet haben, muss der Antrag von einem Mitglied unseres Teams geprüft werden, welches sich in Kürze mit Ihnen in Verbindung setzen wird. Vielen Dank für Ihre Geduld. 
		</p>`,
	},

	validate: {
		validateAgeRelationshipPolicy: `Bitte wählen Sie zuerst „Beziehung zum Versicherungsnehmer“ aus.`,
		requiredField: 'Dieses Feld ist erforderlich',

		// validation messages
		phoneNumber: 'Bitte geben Sie eine gültige Telefonnummer ein.',
		checked: 'Bitte kreuzen Sie das Kontrollkästchen an.',
		currencyPayIn: 'Das Datum muss zwischen heute und nicht mehr als 30 Tagen in der Zukunft liegen.',
		dayBeforeToday: 'Datum muss <= heute sein',
		appSelectRequired: 'Dieses Feld ist erforderlich',
		bmi: 'Muss Nummer sein.',
		cms: 'Muss zwischen 1 und 300 liegen',
		feets: 'Muss zwischen 0 und 9 liegen',
		inches: 'Muss zwischen 0 und 11 liegen',
		kgs: 'Muss zwischen 1 und 300 liegen',
		pounds: 'Muss zwischen 0 und 13 liegen',
		stones: 'Muss zwischen 0 und 47 liegen',
		genderId: 'Bitte wählen Sie Ihr Geschlecht',
		occupationId: 'Bitte wählen Sie Ihren Beruf aus',
		email: 'Das Feld muss eine gültige E-Mail sein',
	},

	notify: {
		// app.vue
		fillRequiredField: 'Bitte füllen Sie die erforderlichen Felder aus',

		// step 2
		quoteUpdated: 'Angebot aktualisiert!',
		selectPackage: 'Bitte Paket auswählen',
		selectProduct: 'Bitte Produkt auswählen',
		selectUnderwritingType: 'Bitte wählen Sie die Zeichnungsart aus',

		//step 3
		fileUploadEmpty: 'Datei ist leer, nicht hochladen.',
		fileUploadSuccess: 'Erfolgreich hochgeladen!',

		//step 5
		notCheckError: 'Bitte kreuzen Sie das Kästchen an',
		waitProcessing: 'Verarbeite .. Bitte warten...',
		cannotApply: `Bewerbung nicht möglich, bitte überprüfen Sie Ihre Angaben`,
	},

	emailContent: {
		customerBody: `<div style='width: 850px;'>
                    <p>Dear {customerName},</p>
                    <p style='margin-left: 300px;'>Congratulations!</p>
                    <p>Thank you for your application for a Morgan Price policy. We are pleased to confirm cover for the coming year.</p>
                    <p>Attached to this email you will find your password protected Policy Certificate, together with your Member card(s), Insurance Product Information Document and Table of Benefits.</p>
                    <p>The password is your date of birth in the following format DDMMYYYY.</p>
                    <div style="margin-bottom: 30px;"></div>
                    <p>The full policy wording can be downloaded from
                      <a href="{policyWordingUrl}">here</a>
                    </p>
                    <p>We request that you check the attached documentation thoroughly and contact us should there be any errors or problems.</p>
                    <p>We thank you for taking out your insurance with Morgan Price International Healthcare and look forward to providing our best service to you as a customer.</p>
                  </div>`,
		customerBodyForBrokerOverride: `<div style='width: 850px;'>
									 <p>Dear Intermediary Partner,</p>
									 <p style='margin-left: 300px;'>Congratulations!</p>
									 <p>Thank you for your application for a Morgan Price policy. We are pleased to confirm cover for the coming year for {customerName}.</p>
									 <p>Attached to this email you will find the password protected Policy Certificate, together with the Member card(s), Insurance Product Information Document and Table of Benefits.</p>
									 <p>The password is the Policy Holders date of birth in the following format DDMMYYYY.</p>
									 <div style="margin-bottom: 30px;"></div>
									 <p>The full policy wording can be downloaded from
										<a href="{policyWordingUrl}">here</a>
									 </p>
									<p>We request that you check the attached documentation thoroughly and contact us should there be any errors or problems.</p>
									<p>We thank you for taking Morgan Price International Healthcare Insurance and look forward to providing our best service to you.</p></div>`,
		customerBodyForBrokerWithNoOverride: `<div style='width: 850px;'>
											<p>Dear {customerName},</p>
											<p style='margin-left: 300px;'>Congratulations!</p>
											<p>Thank you for your application for a Morgan Price policy. We are pleased to confirm cover for the coming year.</p>
											<p>Attached to this email you will find your password protected Policy Certificate, together with your Member card(s), Insurance Product Information Document and Table of Benefits.</p>
											<p>The password is your date of birth in the following format DDMMYYYY.</p>
											<div style="margin-bottom: 30px;"></div>
											<p>The full policy wording can be downloaded from
											<a href="{policyWordingUrl}">here</a>
											</p>
											<p>We request that you check the attached documentation thoroughly and contact us should there be any errors or problems.</p>
											<p>We thank you for taking out your insurance with Morgan Price International Healthcare and look forward to providing our best service to you as a customer.</p>
											</div>
											`,
		applyNowCustomerBody: `<div style='width: 850px;'>
                    <p>Dear {customerName},</p>
                    <p>Thank you for your application for a Morgan Price policy.</p>
                    <p>Attached to this email you will find your application form.</p>
                    <p>The password is your date of birth in the following format DDMMYYYY.</p>
                    <div style="margin-bottom: 30px;"></div>                    
                    <p>We request that you check the attached documentation thoroughly and contact us should there be any errors or problems.</p>
                    <p>One of our Team will be in contact with you shortly.</p>
                  </div>`,
		applyNowCustomerBodyForBrokerOverride: `<div style='width: 850px;'>
											 <p>Dear Intermediary Partner,</p>
											 <p>We have received an online application for the client {customerName}.</p>
											 <p>Attached to this email you will find their application form.</p>
											 <p>The password is their date of birth in the following format DDMMYYYY.</p>
										     <div style="margin-bottom: 30px;"></div>
											 <p>We request that you check the attached documentation thoroughly and contact us should there be any errors or problems.</p>
											 <p>One of our Team will be in contact with you shortly.</p></div>`,
		applyNowCustomerBodyForBrokerWithNoOverride: `<div style='width: 850px;'>
													<p>Dear {customerName},</p>													
													<p>Thank you for your application for a Morgan Price policy.</p>
													<p>Attached to this email you will find your application form.</p>
													<p>The password is your date of birth in the following format DDMMYYYY.</p>
													<div style="margin-bottom: 30px;"></div>
													<p>We request that you check the attached documentation thoroughly and contact us should there be any errors or problems.</p>													
													<p>One of our Team will be in contact with you shortly. </p>
													</div>
													`,
	},

	layout: {
		header: {
			contactUs: 'KONTAKTIERE UNS',
		},

		footer: {
			aboutUs: 'About Us',
			app: 'App',
			appTerms: 'App Terms',
			complaints: 'Complaints',
			news: 'News',
			careers: 'Careers',
			privacyPolicy: 'Privacy Policy',
			cookiePolicy: 'Cookie Policy',
			termsConditions: 'Terms & Conditions',
			FAQ: 'FAQ',
			sitemap: 'Sitemap',
			downloads: 'Downloads',
		},
	},

	step1: {
		header: {
			titleBold: 'Es ist schnell und einfach, sich für Einzelpersonen oder Familien zu bewerben.',
			titleContent: `Abhängig von der von Ihnen gewählten Underwriting-Art müssen Sie möglicherweise die vollständige Krankengeschichte jedes Antragstellers vorlegen.
      {br}Aktuell können Bewerbungen nicht zwischengespeichert werden. Stellen Sie daher bitte sicher, dass Sie alle erforderlichen Informationen zur Hand haben.
      {br}Wenn Sie sich für eine Unternehmens- oder Unternehmensgruppe bewerben möchten, {contactLink} und unser Vertriebsteam wird sich mit Ihnen in Verbindung setzen, um Sie zu unterstützen.
      {br}Makler und Vermittler - vergessen Sie nicht, den eindeutigen Link zu verwenden, den wir Ihnen bereitgestellt haben.
      {br}Alle Deckungen unterliegen obligatorischen Know-Your-Customer-Prüfungen. Während dieses Bewerbungsprozesses müssen Sie einige Ausweisdokumente hochladen.`,
			linkContent: 'Klick hier',
		},
		broker: 'Mäkler:',
		// Policy Holder
		policyHolderTitle: 'Angaben zum Versicherungsnehmer',
		policyHolderDesc: 'Bitte teilen Sie uns etwas über den Versicherungsnehmer mit',
		title: 'Titel',
		forename: 'Vorname',
		surname: 'Familien-oder Nachname',
		dob: 'Geburtsdatum (DD/MM/YYYY)',
		gender: 'Geschlecht',
		occupation: 'Beruf',
		residenceCountry: 'Land, für das diese Deckung erforderlich ist (wo Sie die meiste Zeit verbringen werden)',
		nationalityCountry: 'Land der Staatsangehörigkeit (Land des Hauptreisepasses)',
		tax: 'Steueridentifikationsnummer',
		jobTitle: 'Berufsbezeichnung',
		industry: 'Industrie',
		isPolicyInsured: 'Soll der Versicherungsnehmer versichert werden?',

		// Policy Holder Contact Details
		contactDetailsTitle: 'Kontaktdaten des Versicherungsnehmers',
		contactDetailsDesc:
			'Wir benötigen Ihre Kontaktdaten. Bitte geben Sie mindestens eine der folgenden Angaben an. Ohne diese Informationen sind wir nicht in der Lage, Ihre Police zu verwalten oder Sie im Schadensfall zu unterstützen.',
		internationalDialingCode: 'Internationale Ländervorwahl',
		landlineNumber: 'Festnetznummer',
		internationalDialingCodeList: 'Internationale Ländervorwahl',
		mobileNumber: 'Handynummer',
		emailAddress: 'E-Mail-Addresse',

		// Additional Family Members
		additionalFamilyTitle: 'Zusätzliche Familienmitglieder',
		addFamilyBtn: 'Add Family Members - Familienmitglieder hinzufügen',
		familyMember: 'Family member - Familienmitglied #',
		relationshipToThePolicyHolder: 'Beziehung zum Versicherungsnehmer',

		// Policy Details
		policyDetailsTitle: 'Richtliniendetails',
		policyStartDate: 'An welchem Datum soll die Police beginnen? (DD/MM/YYYY)',
		currencyPayIn: 'In welcher Währung möchten Sie bezahlen?',
	},

	step2: {
		// if print
		product: 'Produkt:',
		area: 'Bereich',
		frequency: 'Frequenz',

		// not print
		selectProduct: 'Ausgewähltes Produkt',
		selectAreaOfCover: 'Wählen Sie den Abdeckungsbereich aus',
		selectPaymentFrequency: 'Wählen Sie Zahlungshäufigkeit aus',
		selectLevelOfCover: 'Wählen Sie die Deckungsstufe aus',
		excludingTax: 'Steuer nicht inbegriffen',
		chooseAnExcess: 'Wählen Sie eine Selbstbeteiligung',
		coInsurance: 'Mitversicherung',
		coInsuranceDefault: '0% Mitversicherung auf alle ambulanten Ansprüche',
		additionalBenefits: 'Zusätzliche Vorteile',
		selectUnderwritingType: 'Wählen Sie Underwriting-Typ aus',
		selectUnderwritingDesc: {
			pleaseNote: 'Bitte beachten Sie: ',
			desc: `Es ist sehr wichtig, dass Sie den Unterschied zwischen verstehen
      Versicherungsarten und dass Sie die für Sie richtige Option gewählt haben.`,
			helpMeChoose: 'AUSWAHLHILFE',
		},

		//control
		updateQuoteBtn: 'Update Quote - Angebot aktualisieren',
		IPID: 'Informationsdokument zu Versicherungsprodukten',
		ToB: 'Leistungstabelle',

		// product not available
		productNotAvailable: 'Dieses Produkt ist nur erhältlich in ',

		//aria
		getProductDocuments: 'Produktunterlagen erhalten',
	},

	step3: {
		proofOfIdentity: 'Identitätsnachweis',
		proofOfAddress: 'Nachweis der Adresse',
		residenceAddress:
			'Adresse in dem Land, für das dieser Versicherungsschutz erforderlich ist (wo Sie die meiste Zeit verbringen werden).',
		countryAddress: 'Adresse des Heimatlandes (Land Ihres Hauptreisepasses)',
		addressDesc: 'Wenn Sie eine Adresse in diesem Land haben, fügen Sie diese bitte hier hinzu',
		//address form
		address1: 'Anschrift Zeile 1',
		address2: 'Anschrift Zeile 2',
		address3: 'Anschrift Zeile 3',
		stateCountry: 'Bundesland/Landkreis',
		city: 'Stadt',
		zipCode: 'Postleitzahl',
		country: 'Land',

		// policy detail
		policyHolder: 'Versicherungsnehmer',
		policyNotInsured: 'Der Versicherungsnehmer ist nicht im Rahmen dieser Police versichert',

		// bmi
		units: 'Einheiten',
		metric: 'Metric - Metrisch',
		imperial: 'Imperial - Kaiserliche',
		height: 'Höhe',
		weight: 'Gewicht',
		statusRefer: 'Status beziehen sich auf:',

		// Supplementary Questions
		supplementaryQuestions: 'Ergänzende Fragen',
		pastime: 'Treiben Sie mehr als einmal pro Woche gefährliche oder Kontaktsportarten oder andere Sportarten?',
		pastimeAsk: `Sport oder Zeitvertreib (Zur Vermeidung von Zweifeln würde dies unter anderem beinhalten
      Dinge, aber nicht beschränkt auf JEDE Kontaktsportart, Klettern ohne Seile, Springreiten jeglicher Art,
      Surfen, Kitesurfen, Freitauchen, Gerätetauchen in über 40 m Tiefe,
      Tauchen aus mehr als 10 m, Tombstoning, Off-Piste-Wintersport oder Verwendung einer Schusswaffe jeglicher Art).`,
		pastimeAskText: `Im Zweifelsfall sollten Sie Ihren Sport oder Ihre körperliche Freizeitbeschäftigung offenlegen.`,
		smoke: 'Rauchen Sie?',
		smokeAsk: 'Bitte geben Sie ein, wie viele pro Tag?',
		companyInsured:
			'Wurde dieser Person jemals der Versicherungsschutz von einer Versicherungsgesellschaft verweigert oder wurde sie zu besonderen Bedingungen aufgenommen?',
		companyInsuredAskDate: 'Datum',
		companyInsuredAskDetails: 'Details eingeben',

		// Physician Details
		physicianDetails: 'Angaben zum Arzt',
		policyNotInsuredPhysician: `Der Versicherungsnehmer soll nicht im Rahmen dieser Police versichert sein Fahren Sie mit Familienmitgliedern fort, 
      da die folgenden Fragen nicht erforderlich sind`,
		physicianDesc: `Bitte teilen Sie uns den Namen und die Anschrift Ihres Haus- oder Hausarztes mit. Wenn Sie nicht
      einen Hausarzt haben, geben Sie bitte den zuletzt besuchten Arzt und das ungefähre Datum an.`,
		// policy form same step 1
		salutations: 'Grüße',
		practiceName: 'Praxisname',
		dateLastVisited: 'Datum des letzten Besuchs (TT/MM/JJJJ)',
		email: 'Email',
		countryCode: 'Landesvorwahl',
		telNumber: 'Telefonnummer',

		haveExistInsured: 'Haben Sie bestehende Krankenversicherungen?',
		haveExistInsuredDate: 'Datum, an dem die Abdeckung endet',
		haveExistInsuredCompanyName: 'Firmenname des Anbieters',

		// documents
		uploadDocument: 'Laden Sie Dokumente zum Identitätsnachweis hoch',
		uploadDocumentDesc1: `Wir sind verpflichtet, einen Nachweis Ihrer Identität für die Know Your Customer (KYC)-Bestimmungen zu sammeln. Wenn Sie eine verwenden
    Mobilgerät verwenden Sie bitte Ihre Kamera, um ein Bild Ihres Dokuments aufzunehmen oder ein Bild Ihres Dokuments hochzuladen.`,
		uploadDocumentDesc2: `Erlaubte Dateiformate sind pdf, docx, doc, rtf, bmp, gif, jpg, jpeg und png mit einer maximalen Größe von 2 MB.`,
		// tutorial upload documents
		uploadDocumentTutorial: 'So laden Sie Dokumente hoch:',
		uploadDocumentStep1: 'Klicken Sie auf "Choose File - Datei wählen".',
		uploadDocumentStep2: 'Fügen Sie beliebig viele Dokumente hinzu',
		uploadDocumentStep3: 'Wenn ALLE Dokumente ausgewählt wurden, wählen Sie Dateien hochladen',

		familyMembers: 'Familienmitglieder',
	},

	step4: {
		underwritingQuestions: 'Underwriting Fragen',
		medicalDeclaration: 'Medical Declaration',
		//medical treatment
		additionalInformation: 'Zusätzliche Information:',

		// other group question
		illnessMedicalNameCondition: `Name der Krankheit/des medizinischen Zustands. Bitte geben Sie ggf. die betroffene Körperstelle an (z. B. linker oder rechter Arm)`,
		dateStarted: 'Datum gestartet',
		dateEnded: 'Datum beendet',
		medicalTreatment: 'Welche medizinische Behandlung wurde durchgeführt?',
		currentMedicationAndDose: 'Name des aktuellen Medikaments und Tagesdosis',
		stayHospitalWithThisCondition:
			'Hatten Sie jemals einen Krankenhausaufenthalt im Zusammenhang mit dieser Erkrankung?',
		currentStatus: 'Aktueller Status',
	},

	step5: {
		summary: 'Zusammenfassung',
		policyNumber: 'Versicherungsnummer',
		productName: 'Produkt',
		areaOfCover: 'Deckungsbereich',
		levelOfCover: 'Deckungsgrad',
		excess: 'Überschuss',
		voluntaryExcess: 'Freiwillige Selbstbeteiligung',
		mandatoryExcess: 'Obligatorischer Selbstbehalt',
		notApplicable: 'Unzutreffend',
		additionalBenefits: 'Zusätzliche Vorteile',
		coInsurance: 'Mitversicherung',
		noneSelected: 'Nichts ausgewählt',
		underwritingType: 'Underwriting-Typ',
		noneAvailable: 'Keine verfügbar',

		pricingTable: 'Preistabelle',
		premiumWithoutTax: 'Prämie ohne MwSt',
		totalTax: 'Gesamtsteuer (basierend auf dem Wohnsitzland)',
		totalPremium: 'Gesamtprämie',
		paymentFrequency: 'Bezahlungshäufigkeit',
		firstPayment: 'Erste Zahlung',
		subsequentPayment: 'Nachzahlung',

		checkIPID: 'Bitte bestätigen Sie, dass Sie die gelesen haben',
		IPID: 'Informationsdokument zu Versicherungsprodukten',
		declarationAndData: 'Erklärung und Datenschutzerklärung',
		declaration: 'Erklärung',
		checkDeclaration: 'Ich habe die Bedingungen gelesen und akzeptiert',

		verifyDesc: 'Sie haben diese/diese Option(en), um fortzufahren:',
		verifyBuyNowDesc: `Wenn Sie die Police mit einer Debit-/Kreditkarte kaufen möchten, wählen Sie unten „Jetzt kaufen“.
          Dadurch gelangen Sie zur Zahlungsabwicklung der Barclays Bank.
          Bitte beachten Sie, dass die Annahme der Police immer noch von einem zufriedenstellenden Know-Your-Customer-Ergebnis abhängig ist.`,
		verifyApplyNowDesc: `Wenn Sie nicht mit Debit-/Kreditkarte bezahlen möchten,
          Wählen Sie Jetzt beantragen, und einer unserer Mitarbeiter wird sich in Kürze mit Ihnen in Verbindung setzen, 
          um die Einrichtung Ihrer Police abzuschließen.`,

		applyNowDesc: `Dieser Antrag muss zur Überprüfung an unsere Underwriter gehen, 
          bevor wir eine endgültige Prämie bereitstellen können.
          Die angezeigte Prämie ist nur ein Richtwert.`,
	},

	contactUs: {
		title: 'Kontaktiere uns',
		desc: 'Leider können wir für Ihre speziellen Umstände online kein Angebot erstellen. Bitte kontaktieren Sie uns per E-Mail für ein Angebot.',
		name: 'Name',
		age: 'Das Alter',
		residenceCountry: 'Land des Wohnsitzes',
		numberDesc: 'Wir können Sie anrufen, wenn Sie möchten - bitte geben Sie Ihre Nummer an',
		countryCode: 'Landesvorwahl',
		number: 'Nummer',
		contactTimeDesc:
			'und eine bevorzugte Zeit, zu der wir Sie anrufen möchten (wir haben von 9:00 bis 17:00 Uhr britischer Zeit geöffnet)',
	},

	months: [
		'January - Januar',
		'February - Februar',
		'March - März',
		'April - April',
		'May - Mai',
		'June - Juni',
		'July - Juli',
		'August - August',
		'September - September',
		'October - Oktober',
		'November - November',
		'December - Dezember',
	],
}
